<template>
  <el-dialog
    :title="$t('addPrivilegeGroup.addRole')"
    :visible.sync="dialogVisible"
    width="50%"
  >
    <el-form :model="addPrivilegeGroupInfo" :rules="rules" ref="form">
      <p v-if="addPrivilegeGroupInfo.errorInfo" style="color:red;">
        {{ addPrivilegeGroupInfo.errorInfo }}
      </p>
      <el-form-item 
        :label="$t('addPrivilegeGroup.roleName')" 
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-input
          v-model="addPrivilegeGroupInfo.name"
          :placeholder="$t('addPrivilegeGroup.roleNamePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('addPrivilegeGroup.roleDesc')"
        prop="description"
        :label-width="formLabelWidth"
      >
        <el-input
          type="textarea"
          v-model="addPrivilegeGroupInfo.description"
          :placeholder="$t('addPrivilegeGroup.roleDescPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveAddPrivilegeGroup">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { savePrivilegeGroup } from '@/api/frame/privilegeGroupApi'

export default {
  name: 'AddPrivilegeGroup',
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: '120px',
      addPrivilegeGroupInfo: {
        name: '',
        description: '',
        errorInfo: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('addPrivilegeGroup.roleNameRequired'), trigger: 'blur' },
          { min: 2, max: 10, message: this.$t('addPrivilegeGroup.roleNameLength'), trigger: 'blur' }
        ],
        description: [
          { max: 200, message: this.$t('addPrivilegeGroup.roleDescLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
      })
    },
    async saveAddPrivilegeGroup() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        this.addPrivilegeGroupInfo.errorInfo = ""
        const res = await savePrivilegeGroup(this.addPrivilegeGroupInfo)
        
        if (res.code === 0) {
          this.$message.success(this.$t('addPrivilegeGroup.addSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
          this.clearForm()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('添加权限组失败:', error)
        this.addPrivilegeGroupInfo.errorInfo = error.message
      }
    },
    clearForm() {
      this.addPrivilegeGroupInfo = {
        name: '',
        description: '',
        errorInfo: ''
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>